import React, { useRef } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';

const FixedCostInput = ({ item, value, onChange }) => {
    const valueRef = useRef(value || 0);

    const handleChange = () => {
        onChange(valueRef.current.value || 0);
    }

    return (
        <TextField
            inputRef={valueRef}
            helperText={item.hint}
            defaultValue={value}
            type="number"
            inputProps={{
                min: 0,
                max: 1000
            }}
            InputProps={{
                startAdornment: <InputAdornment position="start">£</InputAdornment>,
            }}
            onChange={handleChange}
            style={{ minWidth: '100%' }}
        />);
}

export default FixedCostInput;